import {combineReducers} from 'redux';

import {createGatedReducer} from '../util';
import {CONFIG_EDITOR__ACTIONSCOPE} from '../../constants/config-editor';
import assets from './assets';

export default createGatedReducer(
	combineReducers<ConfigEditor.AppState>({assets}),
	CONFIG_EDITOR__ACTIONSCOPE);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/store/reducers/config-editor/index.ts